// extracted by mini-css-extract-plugin
export default {"videoBackground":"Hajj_videoBackground__4ThzE","hajj_title":"Hajj_hajj_title__sH1CJ","hajj_description":"Hajj_hajj_description__0aQ3D","custom_size":"Hajj_custom_size__txSmZ"};